import * as React from "react";
import { Route, Switch } from "react-router-dom";

import Dashboards from "./Ops.Dashboards";
import Users from "./Ops.Users";
import Payments from "./Ops.Payments";
import CardLoads from "./Ops.CardLoads";
import CardTerminals from "./Ops.CardTerminals";
import Merchants from "./Ops.Merchants";
import Devices from "./Ops.Devices";
import Sms from "./Ops.Sms";
import Electricity from "./Ops.Electricity";
import UserMessaging from "./Ops.UserMessaging";
import BillerCategories from "./Ops.BillerCategories";
import RefundRequests from "./Ops.RefundRequests";
import ApplicationStatusMessages from "./Ops.ApplicationStatusMessages";

const Ops = (props) => (
  <Switch>
    <Route
      path="/snapscan/ops/dashboards"
      render={() => <Dashboards {...props} />}
    />

    <Route path="/snapscan/ops/users" render={() => <Users {...props} />} />
    <Route
      path="/snapscan/ops/merchants"
      render={() => <Merchants {...props} />}
    />
    <Route
      path="/snapscan/ops/payments"
      render={() => <Payments {...props} />}
    />
    <Route
      path="/snapscan/ops/card_loads"
      render={() => <CardLoads {...props} />}
    />
    <Route
      path="/snapscan/ops/card_terminals"
      render={() => <CardTerminals {...props} />}
    />
    <Route path="/snapscan/ops/sms" render={() => <Sms {...props} />} />
    <Route
      path="/snapscan/ops/electricity"
      render={() => <Electricity {...props} />}
    />
    <Route path="/snapscan/ops/devices" render={() => <Devices {...props} />} />
    <Route
      path="/snapscan/ops/user_messaging"
      render={() => <UserMessaging {...props} />}
    />
    <Route
      path="/snapscan/ops/biller_categories"
      render={() => <BillerCategories {...props} />}
    />
    <Route
      path="/snapscan/ops/refund_requests"
      render={() => <RefundRequests {...props} />}
    />
    <Route
      path="/snapscan/ops/application_status_messages"
      render={() => <ApplicationStatusMessages {...props} />}
    />
  </Switch>
);

export default Ops;
